/* Micoryan cart: quick-add for "Popular add-ons to reach free delivery".
   Loaded once globally. Mirrors Horizon's native add-to-cart: it requests the
   updated cart section(s) in the same /cart/add.js call and hands them to
   Horizon via a cart:update event, so Horizon morphs them in (no extra
   re-fetch, no race with quantity updates). Event delegation keeps it working
   across cart re-renders; a global guard prevents double-binding. */
(function () {
  if (window.__mcryCartAddInit) return;
  window.__mcryCartAddInit = true;

  function root() {
    try { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
    catch (e) { return '/'; }
  }

  function cartSectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (c) {
      var id = c.getAttribute('data-section-id');
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });
    return ids;
  }

  var busy = false;

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-mcry-add]') : null;
    if (!btn) return;
    e.preventDefault();
    if (busy || btn.hasAttribute('disabled')) return;

    var id = btn.getAttribute('data-mcry-add');
    if (!id) return;

    busy = true;
    var original = btn.textContent;
    btn.textContent = 'Adding…';
    btn.setAttribute('disabled', '');

    var body = { items: [{ id: id, quantity: 1 }] };
    var ids = cartSectionIds();
    if (ids.length) {
      body.sections = ids.join(',');
      body.sections_url = window.location.pathname;
    }

    fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function (data) {
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: data,
            sourceId: 'mcry-addon',
            data: { source: 'mcry-addon', sections: (data && data.sections) || {} }
          }
        }));
      })
      .catch(function () {
        btn.textContent = original;
        btn.removeAttribute('disabled');
      })
      .finally(function () {
        busy = false;
      });
  });
})();
